import React, { useEffect, useState } from 'react';
import './works.css';
import boxlogo from '../../assets/box-logo.png';
import kia from '../../assets/kia.png';
import ebikego from '../../assets/ebikego.png';
import avita from '../../assets/avita.png';
import srm from '../../assets/srm.png';
import sharjah from '../../assets/sharjah.png';
import acer from '../../assets/acer-1.png';
import daewoo from '../../assets/daewoo.png';
import bio from '../../assets/bio.png';
import ebg from '../../assets/ebg.png';
import remo from '../../assets/remo.png';
import iswarya from '../../assets/iswarya-1.png';
import rac from '../../assets/rac.png';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

const Works = () => {
  const [showAllZohoCards, setShowAllZohoCards] = useState(false);
  const [showAllFullStackCards, setShowAllFullStackCards] = useState(false);
  
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  // Zoho CRM projects data
  const zohoProjects = [
    {
      id: 1,
      image: acer,
      imageClass: "acer",
      role: "Fulltime",
      technology: "Zoho CRM, Zoho Products",
      description: "In this project, I was responsible for implementing complete Zoho integrations covering CRM, campaign management, lead capture, and customer engagement. My role included designing and setting up custom workflows, as well as using Deluge scripting to automate processes, reduce manual effort, and improve overall system efficiency."
    },
    {
      id: 2,
      image: daewoo,
      imageClass: "acer",
      role: "Fulltime",
      technology: "Zoho CRM, Zoho Products",
      description: "I managed the integration of Zoho CRM, SalesIQ, Zoho Bookings, Forms, Flow, and Campaigns into the website, setting up automated workflows, real-time engagement via WATI, and custom Deluge functions. This improved responsiveness, boosted sales opportunities, and enhanced overall business efficiency."
    },
    {
      id: 3,
      image: ebikego,
      imageClass: "ebikego",
      role: "Fulltime",
      technology: "Zoho CRM, Zoho Products",
      description: "In this project, I integrated Zoho CRM and other Zoho tools like SalesIQ, Zoho Bookings, Zoho Forms, Zoho Flow, and Zoho Campaigns into the website to automate the sales process. I worked on setting up workflows and email notifications for campaign management, using WATI for user engagement to streamline communication and boost sales efficiency. Additionally, I utilized Deluge to write custom functions, enhancing the automation and functionality across the Zoho ecosystem."
    },
    {
      id: 4,
      image: bio,
      imageClass: "ebikego",
      role: "Fulltime",
      technology: "Zoho CRM, Zoho Products",
      description: "I implemented full Zoho CRM automation covering sales, appointment scheduling, lead tracking, and patient management. I built an end-to-end lead-to-appointment conversion process with automated nurturing and follow-ups, ensuring consistent engagement that improved sales conversions. For management, I set up a Zoho dashboard to provide easy access to performance insights and real-time tracking."
    },
    {
      id: 5,
      image: boxlogo,
      imageClass: "ebikego",
      role: "Fulltime",
      technology: "Salesforce",
      description: "I customized Salesforce to streamline sales and marketing operations. This included creating forms for automated lead capture, setting up assignment rules, and implementing workflow automation. I also built automation for email marketing and campaign management, ensuring smoother processes and improved lead handling."
    },
    {
      id: 6,
      image: ebg,
      imageClass: "ebikego",
      role: "Fulltime",
      technology: "Zoho CRM, Zoho Products",
      description: "I implemented complete Zoho integration for CRM, campaign management, lead capture, and customer engagement. I enhanced automation using custom workflows and Deluge scripting, reducing manual effort and improving efficiency. I also set up dashboards for real-time performance tracking, optimized lead nurturing processes, and supported sales teams with automated follow-ups to boost conversions."
    }
  ];

  // Full-Stack Development projects data
  const fullStackProjects = [
    {
      id: 1,
      image: boxlogo,
      imageClass: "box-logo",
      role: "Fulltime",
      technology: "Django, Python",
      description: "In this project, I developed and maintained the web application using Django, Python, and SQLite3 for the backend, while creating responsive frontend interfaces with CSS and JavaScript. I focused on optimizing performance and ensuring smooth functionality across the platform."
    },
    {
      id: 2,
      image: kia,
      imageClass: "kia",
      role: "Fulltime",
      technology: "Django, Python",
      description: "I contributed to the development and maintenance of this web application using Django and Python for the backend, with SQLite3 for data management. I also worked on the frontend, building responsive interfaces using CSS and JavaScript to ensure a seamless user experience."
    },
    {
      id: 3,
      image: srm,
      imageClass: "srm mb-3",
      role: "Fulltime",
      technology: "Nuxt JS, Tailwind CSS",
      description: "In this project, I developed and maintained the website using Nuxt.js for server-side rendering and dynamic content handling. I used Tailwind CSS for creating a responsive and modern design, ensuring a smooth user experience across all devices. Additionally, I focused on optimizing the site's performance and ensuring fast loading times."
    },
    {
      id: 4,
      image: sharjah,
      imageClass: "sharjah mb-3",
      role: "Fulltime",
      technology: "React JS",
      description: "In this project, we migrated the website from WordPress to React JS. My role involved developing the pages and adding animations to enhance the user experience, making the site more interactive and visually appealing."
    },
    {
      id: 5,
      image: avita,
      imageClass: "avita mb-3",
      role: "Fulltime",
      technology: "Webflow",
      description: "In this project, I developed additional pages and built a custom CMS system using Webflow, enabling the client to easily manage and update their content. I also ensured the website was optimized for performance and responsiveness, providing a seamless experience across devices."
    },
    {
      id: 6,
      image: remo,
      imageClass: "sharjah mb-3",
      role: "Fulltime",
      technology: "Next JS",
      description: "Developed and maintained a responsive web application using Next.js and Tailwind CSS, delivering fast load times and a seamless mobile experience. Managed the project end-to-end by coordinating with designers and developers, defining timelines, and ensuring on-time delivery with high performance and usability."
    }
  ];

  // Get cards to display based on state
  const displayedZohoProjects = showAllZohoCards ? zohoProjects : zohoProjects.slice(0, 3);
  const displayedFullStackProjects = showAllFullStackCards ? fullStackProjects : fullStackProjects.slice(0, 3);

  const toggleShowAllZoho = () => {
    setShowAllZohoCards(!showAllZohoCards);
  };

  const toggleShowAllFullStack = () => {
    setShowAllFullStackCards(!showAllFullStackCards);
  };

  return (
    <section id='Works'>
      <div className='container'>
        <div className='text-center mt-5 mb-4' data-aos="fade-up">
          <h1>My <span className="introText">Portfolio</span></h1>
        </div>
        {/* Full-Stack Development & No code Platform Projects Section */}
        <div className='text-center mt-5 mb-4' data-aos="fade-up">
          <h6><span className="introText">Full-Stack Development & No code Platform Projects</span></h6>
        </div>
        <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-1'>
          {displayedFullStackProjects.map((project, index) => (
            <div className="col-lg-4" key={project.id} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="work-bar flip-card">
                <div className="flip-card-inner">
                  <div className="flip-card-front text-center mb-4">
                    <img src={project.image} alt="" className={project.imageClass} width="auto" />
                    <div className='para-text'>
                      <p>Role: {project.role}</p>
                      <p className="m-0">Technology: {project.technology}</p>
                    </div>
                  </div>
                  <div className="flip-card-back text-center">
                    <p>{project.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Read More Button for Full-Stack Section */}
        {fullStackProjects.length > 3 && (
          <div className='text-center mt-4' data-aos="fade-up">
            <button 
              className='read-more-projects-btn'
              onClick={toggleShowAllFullStack}
            >
              {showAllFullStackCards ? 'Show Less' : 'Read More Projects'}
            </button>
          </div>
        )}


        {/* Zoho CRM & Automation Projects Section */}
        <div className='text-center mt-5 mb-4' data-aos="fade-up">
          <h6><span className="introText">Zoho CRM & Automation Projects </span></h6>
        </div>
        <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-1'>
          {displayedZohoProjects.map((project, index) => (
            <div className="col-lg-4" key={project.id} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="work-bar flip-card">
                <div className="flip-card-inner">
                  <div className="flip-card-front text-center mb-4">
                    <img src={project.image} alt="" className={project.imageClass} width="auto" />
                    <div className='para-text'>
                      <p>Role: {project.role}</p>
                      <p className="m-0">Technology: {project.technology}</p>
                    </div>
                  </div>
                  <div className="flip-card-back text-center">
                    <p>{project.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Read More Button for Zoho Section */}
        {zohoProjects.length > 3 && (
          <div className='text-center mt-4' data-aos="fade-up">
            <button 
              className='read-more-projects-btn'
              onClick={toggleShowAllZoho}
            >
              {showAllZohoCards ? 'Show Less' : 'Read More Projects'}
            </button>
          </div>
        )}

        
        {/* Other Projects Sections - Keep Original Layout */}
        <div className='text-center mt-5 mb-4' data-aos="fade-up">
          <h6><span className="introText">Social Media Operations Projects</span></h6>
        </div>
        <div className="col-lg-12 d-flex justify-content-center flex-wrap gap-3 mt-2">
          <div className="col-lg-4" data-aos="fade-up">
            <div className="work-bar flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front text-center mb-4">
                  <img src={iswarya} alt="" className="driswarya mb-3" width="auto" />
                  <div className='para-text'>
                    <p>Role: Freelance</p>
                    <p className="m-0">Technology: Photoshop, Canva</p>
                  </div>
                </div>
                <div className="flip-card-back text-center">
                  <p>In this project, I managed social media operations for a naturopathy clinic, creating monthly posts, videos, and carousel ads with engaging content. By leveraging trending topics and video-based posts, interaction and views increased by 75% compared to usual performance. I also designed interactive festival posts that boosted audience engagement and client satisfaction through creative, impactful designs.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4" data-aos="fade-up">
            <div className="work-bar flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front text-center mb-4">
                  <img src={rac} alt="" className="milliard mb-3" width="auto" />
                  <div className='para-text'>
                    <p>Role: Freelance</p>
                    <p className="m-0">Technology: Photoshop, Canva</p>
                  </div>
                </div>
                <div className="flip-card-back text-center">
                  <p>For a beauty parlour startup, I handled social media operations by creating engaging posts and videos to support business growth. The content strategy focused on building brand visibility, attracting new customers, and showcasing services through creative and interactive designs.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Works;
